import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { selector } from 'recoil';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { refreshIsGiftCardEligibleSelectorAtom } from '../atoms/refreshIsGiftCardEligibleSelectorAtom';
import { isLoggedOnSelector } from './isLoggedOnSelector';

export const isGiftCardEligibleSelector = selector<boolean>({
    key: 'isGiftCardEligibleSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        get(refreshIsGiftCardEligibleSelectorAtom);
        const isLoggedOn = get(isLoggedOnSelector);

        if (!isLoggedOn) {
            return true;
        }
        const isGiftCardEligible = await OnlineSalesUnauthenticated.checkIsGiftCardEligible(
            jobNumber,
            sessionId
        );
        return isGiftCardEligible;
    }
});
